<template>
  <!-- 组件主盒子 -->
  <div class="stbox">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报警信息列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.device_name" placeholder="请输入设备名"></el-input>
      </el-form-item>
      <el-form-item label="请选择故障类型" prop="alarm_type">
        <el-select v-model="formInline.alarm_type" placeholder="请选择">
          <el-option v-for="item in listData.alarm_type" :key="item" :label="item"
                     :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" plain icon="el-icon-refresh" @click="refresh()">重置</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-lock" @click="batchDelete()">删除</el-button>
      </el-form-item>
    </el-form>

    <el-table size="small" ref="alarmTable" :data="listData" highlight-current-row
              v-loading="loading" border
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column sortable prop="id" label="ID" show-overflow-tooltip></el-table-column>
      <el-table-column prop="dname" label="设备名" show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="所属分组" show-overflow-tooltip></el-table-column>
      <el-table-column prop="alarm_status" label="故障类型" show-overflow-tooltip></el-table-column>
      <el-table-column prop="alarm_time" label="报警时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="报警状态" show-overflow-tooltip>
        <span class="greenbg">已处理</span>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <span class="delete" @click="deleteAlarm(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height:10px;"></div>
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <div style="height:20px;"></div>
  </div>
</template>
<script type="text/ecmascript-6">
import Pagination from '../../components/Pagination'
import {alarm, alarmDelete} from "../../api/userMG";

export default {
  name: "welcome",
  data() {
    return {
      formInline: {
        page: 1,
        pageSize: 10,
        limit: 10,
        device_name: '',
        alarm_type: '',
      },
      listData: [], //用户数据
      loading: false,
      selectedId: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 导入组件
  components: {
    Pagination
  },
  // 创建完毕状态(里面是操作)
  created() {
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getdata(this.formInline)
  },
  // 分页插件事件
  callFather(parm) {
    this.formInline.page = parm.currentPage
    this.formInline.limit = parm.pageSize
    this.getdata(this.formInline)
  },
  // 里面的函数只有调用才会执行
  methods: {
    getdata(parameter) {
      this.loading = true
      alarm(parameter).then(res => {
        this.listData = res.items.historyAlarm
        this.loading = false
        this.pageparm.currentPage = this.formInline.page
        this.pageparm.pageSize = this.formInline.limit
        this.pageparm.total = res.pageInfo.total
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    deleteAlarm(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          alarmDelete({id: row.id})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '报警信息已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('报警信息删除失败,请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    batchDelete() {
      let selectedRows = this.$refs.alarmTable.selection
      if (selectedRows.length == 0) {
        this.$message.error('请先选择报警信息！')
        return false;
      }
      this.showMove = true;
      let ids = []
      selectedRows.forEach(item => {
        ids.push(item.id)
      })
      this.selectedId = ids

      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          alarmDelete({id: this.selectedId})
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '报警信息已删除！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('报警信息删除失败,请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    refresh() {
      this.formInline.device_name = ''
      this.formInline.alarm_type = ''
      this.getdata(this.formInline)
    },
    search() {
      this.getdata(this.formInline)
    },
  }
};
</script>
<style>
.user-search {
  margin-top: 30px;
}

.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.stbgc {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
  padding: 0px 16px;
}

.stsearch {
  text-align: center;
}

.text-c {
  text-align: center;
}

.delete {
  color: #0052D9;
}

.greenbg {
  background: rgba(13, 172, 120, 0.15);
  font-size: 12px;
  padding: 4px 8px;
  font-weight: 400;
  line-height: 22px;
  color: #0DAC78;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/alarm.vue